import { AuthenticatedRoutesType } from '../router/routes';

/**
 * Screens a deployment can switch off.
 *
 * Same shape as `LOCKS_CONFIG` and `CREDIT_SCORE_CONFIG`: the value is the
 * string `VISIBLE` or `HIDDEN`, and anything else — including the variable not
 * being set at all — counts as hidden. A build that says nothing about a
 * screen does not get it, which is the safe direction for a screen that names
 * one bank's data centres.
 */
const isVisible = (value?: string) => value === 'VISIBLE';

/**
 * Data residency & tenant isolation. Off unless `DATA_RESIDENCY_CONFIG` says
 * otherwise, because the screen describes a specific bank's two installations
 * and means nothing on a build themed for anyone else.
 */
export const isDataResidencyVisible = (): boolean => isVisible(process.env.REACT_APP_DATA_RESIDENCY_CONFIG);

/**
 * Authenticated routes this build does not serve.
 *
 * Returns route *keys*, which is what `ROUTES` is indexed by — the router maps
 * these through `ROUTES[key]` the same way it does the wrong-tenant list.
 */
export const getHiddenRoutes = (): AuthenticatedRoutesType[] => {
    const hidden: AuthenticatedRoutesType[] = [];

    if (!isDataResidencyVisible()) {
        hidden.push('DATA_RESIDENCY');
    }

    return hidden;
};
